import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { alertsAnimation, AuthService } from 'src/app/auth.service';
import { ThemingService, ShopTheming } from 'src/app/theming.service';
import { SettingsService } from 'src/app/settings.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  animations: [ alertsAnimation ],
})
export class UsersComponent implements OnInit {
  public shopTheme: ShopTheming[] = [];

  loaded: boolean = false;
  fullUserList: any = {};
  staffList: any = [];
  //owner: any = {};
  owners: any = [];
  staffMembers: number = 0;
  staffMaxMembers: number = 0;
  currentUser: any;
  isCurrentUserOwner: boolean = false;
  _settingsService: SettingsService;
  permissions: any = {};

  constructor(
    private authService: AuthService,
    private router: Router,
    private themingService: ThemingService,
    private settingsService: SettingsService
  ) {
      this.shopTheme = this.themingService.shopTheming;
      this._settingsService = settingsService;
  }

  async ngOnInit(): Promise<void> {
    try {
      // Paso 1: Obtener permisos del usuario
      this.permissions = await this.authService.getUserPermissions();

      // Paso 2: Obtener lista completa de usuarios
      this.fullUserList = await this.authService.getUsers();

      // Paso 3: Procesar usuarios (bucle para contar staff y separar owners/staff)
      const shopIdStr = this.themingService.shopTheming[0].shopId.toString();
      this.staffMembers = 0;  // Reinicia contador
      this.owners = [];       // Reinicia arrays
      this.staffList = [];

      for (let i = 0; i < this.fullUserList.length; i++) {
        const userIds = this.fullUserList[i].shop_access.split(',').map((id: any) => id.trim());
        if (userIds.includes(shopIdStr)) {
          this.staffMembers++;  // Contador total de miembros con acceso
          if (this.fullUserList[i].user_role === 'Owner') {
              this.owners.push(this.fullUserList[i]);
          } else {
              this.staffList.push(this.fullUserList[i]);
          }
        }
      }
      // Actualiza staffMembers basado en la lista filtrada (opcional, pero consistente)
      this.staffMembers = this.staffList.length;

      // Paso 4: Obtener usuario actual y verificar rol
      this.currentUser = await this.authService.currentAuthUser();
      this.isCurrentUserOwner = (this.currentUser.attributes['custom:user_role'] === "Owner" || this.permissions.userRoles === true);

      // Paso 5: Procesar plan de suscripción
      const currentPlan = this.shopTheme[0].shopSubscription;
      this.staffMaxMembers = currentPlan.shopMaxUsers;
      // Si necesitas el switch comentado, descomentarlo aquí, pero parece que ya no se usa

    } catch (error) {
        console.error('Error en ngOnInit:', error);
        // Opcional: Manejo adicional, como mostrar un mensaje al usuario
    } finally {
        // Siempre se ejecuta, independientemente de errores
        this.loaded = true;
    }
}

  goToAdd(){
    this.router.navigate(['/add-user'], {state: {max: this.staffMaxMembers}});
  }

  goToOwnerProfile(){
    if(this.isCurrentUserOwner){
      this.router.navigate(['/profile']);
    }
  }

  routeUser(user: any){
    if(this.isCurrentUserOwner){
      this.router.navigate(['/users', user.Username]);
    }else if(this.currentUser.username === user.Username){
      this.router.navigate(['/profile']);
    }
  }

  setEditingOwner(){
    this._settingsService.setEditingOwner()
  }

  setEditingUser(username: string){
    this._settingsService.setEditingUser(username)
  }

  getCreatingUser(){
    this._settingsService.getCreatingUser()
  }

  setCreatingUser(){
    this._settingsService.setCreatingUser();
  }
}

